import { html } from '@polymer/polymer/polymer-element';
import { KatapultWidget } from './katapult-widget';
import '../../feedback/feedback-element.js';

/* global firebase, FirebaseWorker, k, katapultAuth */

class KatapultFeedbackWidget extends KatapultWidget {
  static get widgetTitleTemplate() {
    return html`Feedback Widget`;
  }

  static get bodyTemplate() {
    return html` <feedback-element style="height: 800px" inbox></feedback-element> `;
  }
}

window.customElements.define('katapult-feedback-widget', KatapultFeedbackWidget);
